import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuard1FA } from './auth-guard-1fa.service';
import { map } from 'rxjs/operators';


@Injectable()
export class AuthGuard extends AuthGuard1FA implements CanActivate {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return super.canActivate(route, state).pipe(
      map((activate: boolean) => {
        if (activate) {
          if (this.auth.requires2FA()) {
            if (this.auth.requires2FAConfig()) {
              this.router.navigate(['2FAConfig']);
            } else {
              this.router.navigate(['2FA']);
            }
            return false;
          }
        }
        return activate;
      })
    );
  }

}
